export const StarIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="24"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
      {...props}
    >
      <g id="Star" clipPath="url(#clip0_1_3475)">
        <path
          id="Vector"
          d="M12 2.489L15.09 8.751L22 9.755L17 14.629L18.18 21.511L12 18.261L5.82 21.511L7 14.629L2 9.755L8.91 8.751L12 2.489Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_3475">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
